import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import CustomButton from "../components/CustomButton";
const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
  padding: 20px 0px;
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;
  @media (max-width: 767px) {
    order: 1;
  }
  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.2;
    margin-bottom: 15px;
    text-transform: uppercase;
    text-align: right;

    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
  > p {
    font-size: 16px;
    font-family: var(--montserrat);
    line-height: 1.5;
    margin-bottom: 5px;
    text-align: right;
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 567px) {
      font-size: 12px;
    }
  }
`;

const Right = styled.div`
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  @media (max-width: 767px) {
    order: 2;
  }
`;

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;
const MarketPlace = () => {
  const handleNavigate = () => {
    window.open("https://alpharegiment.in/", "_blank");
  };
  return (
    <>
      <CustomHelmet
        title="Arcaptor: Democratizing Education in India with Marketplaces"
        description="Arcaptor leverages innovative marketplaces to democratize education in India, making quality learning accessible, inclusive, and affordable for all."
      />
      <MainLayout>
        <Section>
          <Container>
            <Content>
              <Right>
                {" "}
                <img src="/images/marketplace.png" alt="marketPlace" />
              </Right>

              <Left>
                <h1>
                  Empowering educators to teach their way, with freedom and
                  passion.
                </h1>
                <p>#AlphaRegiment</p>
                <p>#AlphaUPSC</p>
              </Left>
            </Content>
          </Container>
        </Section>
        <Container>
          <TextContent>
            <h2 className="main_heading">
              Explore Alpha Regiment: Your Ultimate Marketplace for Armed Forces
              Preparation
            </h2>
            <p>
              Alpha Regiment is a comprehensive platform that brings together
              the best online and offline courses for every stage of armed
              forces preparation. From written exams to SSB interviews, physical
              fitness, medical check-ups, and spoken English, Alpha Regiment
              offers a one-stop solution for aspiring candidates
            </p>
            <br />
            <h4>Why Choose Alpha Regiment?</h4>
            <br />
            <ul>
              <li>
                <strong>1. Courses for Every Stage:</strong> Whether you're
                preparing for written exams, interviews, or physical fitness,
                Alpha Regiment has tailored courses to suit your needs.
              </li>
              <li>
                <strong>2. Top Educators and Coaches:</strong>
                Learn from the best—experienced teachers, retired military
                officers, fitness trainers, and medical professionals who bring
                unparalleled expertise to your preparation.{" "}
              </li>
              <li>
                <strong>3. Comprehensive Medical Support:</strong>
                Access retired military doctors for detailed medical check-ups,
                ensuring you're fully prepared for the medical evaluation stage.
              </li>
              <li>
                <strong>4. Physical Fitness Training:</strong> Benefit from
                online and offline fitness courses with advanced tools to track
                and enhance your workouts, making online sessions as effective
                as in-person training.
              </li>
              <li>
                <strong>5. Spoken English Mastery:</strong> Improve your English
                skills with expert trainers to excel in interviews and
                communication.
              </li>
            </ul>
            <br />

            <h4>For Educators, Trainers, and Coaches</h4>
            <br />
            <p>
              Alpha Regiment is also the ideal platform for teachers, retired
              officers, and trainers to launch their courses. With all essential
              tools and marketing handled by us, you can focus solely on
              teaching and mentoring.
            </p>
            <br />
            <h4>Features That Set Alpha Regiment Apart</h4>
            <br />
            <ul>
              <li>
                <strong>1. All-in-One Marketplace:</strong>
                No matter the stage of preparation, find everything you need in
                one place.
              </li>
              <li>
                <strong>2. Online and Offline Options:</strong>
                Choose from flexible learning modes that fit your schedule and
                location.
              </li>
              <li>
                <strong>3. Expert-Led Programs:</strong>
                Access courses designed and delivered by top-tier professionals
                with a deep understanding of armed forces requirements.
              </li>
              <li>
                <strong>4. Advanced Tools for Trainers:</strong> Coaches can
                track, analyze, and enhance students’ progress with cutting-edge
                tools, ensuring optimal outcomes.
              </li>
            </ul>
            <br />
            <h4>A Growing Ecosystem of Marketplaces</h4>
            <br />
            <p>
              Alpha Regiment is just the beginning! We are expanding to cater to
              aspirants in other competitive fields. Platforms like Alpha UPSC
              and Alpha SSC are on the horizon, bringing the same level of
              expertise and comprehensive solutions to help candidates prepare
              for these prestigious examinations.
            </p>
            <br />

            <h4>Join the Alpha Regiment Community</h4>
            <br />
            <p>
              Alpha Regiment isn’t just a marketplace; it’s a thriving community
              dedicated to helping students achieve their dreams of joining the
              armed forces. Whether you're starting with written exams, focusing
              on SSB interviews, or refining your fitness and medical readiness,
              Alpha Regiment empowers you with the resources and guidance you
              need to succeed.
            </p>

            <br />

            <h4>
              Prepare with the best and grow with us as we expand to serve more
              aspirants across diverse fields. Alpha Regiment—your partner in
              success!{" "}
            </h4>

            <CustomButton
              title="View Alpha Regiment"
              onClick={handleNavigate}
              width="180px"
              className="campus"
            />
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default MarketPlace;
